import { render, staticRenderFns } from "./Bangbangpindan.vue?vue&type=template&id=4a819161&scoped=true&"
import script from "./Bangbangpindan.vue?vue&type=script&lang=js&"
export * from "./Bangbangpindan.vue?vue&type=script&lang=js&"
import style0 from "./Bangbangpindan.vue?vue&type=style&index=0&id=4a819161&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a819161",
  null
  
)

export default component.exports